<template>
  <v-container id="dashboard" fluid>
    <v-row>
      <v-col cols="12">
        <div class="d-flex justify-center">
          <v-subheader class="display-1 font-weight-bold has-border"
            >Communication</v-subheader
          >
        </div>
      </v-col>
      <v-col
        cols="12"
        sm="6"
        md="4"
        lg="3"
        v-if="(isStudent && modules.studentAnnouncements) || !isStudent"
      >
        <router-link
          :to="{
            name: isStudent ? 'studentAnnouncements' : 'announcementList',
            params: {
              studentAdmissionId: isStudent
                ? user.userStudentMap.studentAdmissionID
                : ''
            }
          }"
          title="Announcements"
        >
          <clickable-card
            gotoIcon="mdi-arrow-top-right"
            icon="mdi-bullhorn-outline"
            color="accent"
            cardTitle="Announcements"
          >
          </clickable-card>
        </router-link>
      </v-col>

      <v-col
        cols="12"
        sm="6"
        md="4"
        lg="3"
        v-if="(isStudent && modules.diaryStudent) || !isStudent"
      >
        <router-link
          :to="{
            name: isStudent ? 'diaryStudent' : 'viewStudentGeneralDiary',
            params: {
              studentAdmissionId: isStudent
                ? user.userStudentMap.studentAdmissionID
                : ''
            }
          }"
          title="Class Diary"
        >
          <clickable-card
            gotoIcon="mdi-arrow-top-right"
            icon="mdi-book-open-variant"
            color="warning"
            cardTitle="Class Diary"
          >
          </clickable-card>
        </router-link>
      </v-col>

      <v-col
        cols="12"
        sm="6"
        md="4"
        lg="3"
        v-if="(isStudent && modules.studentCalender) || !isStudent"
      >
        <router-link
          :to="{ name: isStudent ? 'studentCalender' : 'eventCalendarList' }"
          title="Event Calendar"
        >
          <clickable-card
            gotoIcon="mdi-arrow-top-right"
            icon="mdi-calendar"
            color="info"
            cardTitle="Event Calendar"
          >
          </clickable-card>
        </router-link>
      </v-col>

      <v-col
        cols="12"
        sm="6"
        md="4"
        lg="3"
        v-if="(isStudent && modules.studentGallery) || !isStudent"
      >
        <router-link
          :to="{
            name: isStudent ? 'studentGallery' : 'photogallaryList',
            params: {
              studentAdmissionId: isStudent
                ? user.userStudentMap.studentAdmissionID
                : ''
            }
          }"
          title="Gallery"
        >
          <clickable-card
            gotoIcon="mdi-arrow-top-right"
            icon="mdi-file-image"
            color="pink"
            cardTitle="Gallery"
          >
          </clickable-card>
        </router-link>
      </v-col>
    </v-row>

    <v-row>
      <div
        class="inside"
        :class="{ 'mt-4': $vuetify.breakpoint.mdAndUp }"
        tag="section"
        v-if="
          (isStudent && modules.studentAttendance) ||
          (isStudent && modules.studentReport) ||
          !isStudent
        "
      >
        <v-col cols="12">
          <div class="d-flex justify-center">
            <v-subheader class="display-1 font-weight-bold has-border"
              >Academics</v-subheader
            >
          </div>
        </v-col>

        <v-col
          cols="12"
          sm="6"
          md="4"
          lg="3"
          v-if="(isStudent && modules.studentAttendance) || !isStudent"
        >
          <router-link
            :to="{
              name: isStudent ? 'studentAttendance' : 'giveAttendance',
              params: {
                studentId: isStudent
                  ? user.userStudentMap.studentAdmissionID
                  : ''
              }
            }"
            title="Attendance"
          >
            <clickable-card
              gotoIcon="mdi-arrow-top-right"
              icon="mdi-check-bold"
              color="darkblue"
              cardTitle="Attendance"
            >
            </clickable-card>
          </router-link>
        </v-col>
        <v-col
          cols="12"
          sm="6"
          md="4"
          lg="3"
          v-if="(isStudent && modules.studentReport) || !isStudent"
        >
          <router-link
            :to="{
              name: isStudent ? 'studentReport' : 'studentDetails',
              params: {
                studentAdmissionId: isStudent
                  ? user.userStudentMap.studentAdmissionID
                  : ''
              }
            }"
            title="Term Report Card"
          >
            <clickable-card
              gotoIcon="mdi-arrow-top-right"
              icon="mdi-file-chart-outline"
              color="success"
              cardTitle="Term Report Card"
            >
            </clickable-card>
          </router-link>
        </v-col>
      </div>
    </v-row>

    <v-row>
      <div
        class="inside"
        :class="{ 'mt-4': $vuetify.breakpoint.mdAndUp }"
        tag="section"
      >
        <v-col cols="12">
          <div class="d-flex justify-center">
            <v-subheader class="display-1 font-weight-bold has-border"
              >Fee Configuration</v-subheader
            >
          </div>
        </v-col>

        <v-col
          cols="12"
          sm="6"
          md="4"
          lg="3"
          v-if="(isStudent && modules.studentAccount) || !isStudent"
        >
          <router-link
            :to="{
              name: 'studentAccount',
              params: {
                studentId: isStudent
                  ? user.userStudentMap.studentAdmissionID
                  : ''
              }
            }"
            title="Student Account"
          >
            <clickable-card
              gotoIcon="mdi-arrow-top-right"
              icon="mdi-account"
              color="lime"
              cardTitle="Student Account"
            >
            </clickable-card>
          </router-link>
        </v-col>
      </div>
    </v-row>
  </v-container>
</template>

<script>
import Utils from '@/utils'
import ClickableCard from '@/components/template/ClickableCard'
import stores from '@/stores'
export default {
  components: { ClickableCard },
  data () {
    return {
      user: stores.user.me,
      isStudent: false,
      modules: {
        diaryStudent: this.checkModuleAccess('diaryStudent'),
        studentAnnouncements: this.checkModuleAccess('studentAnnouncements'),
        studentCalender: this.checkModuleAccess('studentCalender'),
        studentGallery: this.checkModuleAccess('studentGallery'),
        studentAttendance: this.checkModuleAccess('studentAttendance'),
        studentReport: this.checkModuleAccess('studentReport'),
        studentAccount: this.checkModuleAccess('studentAccount')
      }
    }
  },
  created: async function () {
    if (
      this.user.userStudentMap &&
      this.user.userStudentMap.studentAdmissionID
    ) {
      this.isStudent = true
    }
  },
  methods: {
    checkModuleAccess: function (moduleName) {
      return Utils.helper.checkAccessByModule(this.$route, moduleName)
    }
  }
}
</script>
